<template>
    <div id="project-info" v-bind:class="{ slide: true, 'slide-enter': show, 'slide-leave': !show }">
        <div id="info">
            <p>Want to learn how to build this Vue.js app?</p>
            <p>This app is one of three projects you'll build in the <strong>Ultimate Vue.js
                Developers</strong> course.</p>
            <p>Leave your email address and we'll send you more info!</p>

            <form v-on:submit="clearEmail"
                  action="//getjsdojo.us13.list-manage.com/subscribe/post?u=cd0e0c3fe7829518b809554a8&amp;id=ae2f1465e2"
                  method="post" name="mc-embedded-subscribe-form" target="_blank" novalidate>
                <div class="inputs">
                    <input v-model="email" type="email" value="" name="EMAIL" class="email" id="mce-EMAIL"
                           placeholder="Email address" v-focus>
                    <input type="hidden" name="COURSE" value="0">
                    <input type="hidden" name="SOURCE" value="proj_pos">
                    <input type="submit" value="Tell me more" name="subscribe" id="mc-embedded-subscribe" class="button">
                </div>
                <div>
                    <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
                    <div style="position: absolute; left: -5000px;" aria-hidden="true">
                        <input type="text" name="b_cd0e0c3fe7829518b809554a8_607f131620" tabindex="-1" value="">
                    </div>
                </div>
            </form>

        </div>
        <div id="tab" v-on:click="show = !show">Learn To Build Me!
            <svg v-if="show" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="10px" height="10px" viewBox="0 0 284.929 284.929" style="enable-background:new 0 0 284.929 284.929;" xml:space="preserve"><g><path d="M282.082,195.285L149.028,62.24c-1.901-1.903-4.088-2.856-6.562-2.856s-4.665,0.953-6.567,2.856L2.856,195.285 C0.95,197.191,0,199.378,0,201.853c0,2.474,0.953,4.664,2.856,6.566l14.272,14.271c1.903,1.903,4.093,2.854,6.567,2.854 c2.474,0,4.664-0.951,6.567-2.854l112.204-112.202l112.208,112.209c1.902,1.903,4.093,2.848,6.563,2.848 c2.478,0,4.668-0.951,6.57-2.848l14.274-14.277c1.902-1.902,2.847-4.093,2.847-6.566 C284.929,199.378,283.984,197.188,282.082,195.285z"></path></g></svg>
            <svg v-else version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="10px" height="10px" viewBox="0 0 284.929 284.929" style="enable-background:new 0 0 284.929 284.929;" xml:space="preserve"><g><path d="M282.082,76.511l-14.274-14.273c-1.902-1.906-4.093-2.856-6.57-2.856c-2.471,0-4.661,0.95-6.563,2.856L142.466,174.441 L30.262,62.241c-1.903-1.906-4.093-2.856-6.567-2.856c-2.475,0-4.665,0.95-6.567,2.856L2.856,76.515C0.95,78.417,0,80.607,0,83.082 c0,2.473,0.953,4.663,2.856,6.565l133.043,133.046c1.902,1.903,4.093,2.854,6.567,2.854s4.661-0.951,6.562-2.854L282.082,89.647 c1.902-1.903,2.847-4.093,2.847-6.565C284.929,80.607,283.984,78.417,282.082,76.511z"></path></g></svg>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                show: false,
                email: ''
            }
        },
        methods: {
            clearEmail() {
                setTimeout(() => {
                    this.email = '';
                }, 1);
            }
        },
        directives: {
            focus: {
                update(el) {
                    el.focus()
                }
            }
        }
    }

</script>
<style lang="scss" rel="stylesheet/scss">

    // Colors
    $punch: #D73128;
    $border-color: darken($punch, 10%);
    $grey: #DCDCDC;
    $white: #FFFFFF;
    $black: #000000;

    // Fonts
    $font-sm: 13px;
    $font-md: 16px;

    $break-point: 400px;

    .slide {
        transition: transform 0.3s;
    }

    .slide-enter {
        transform: translateY(0);
    }

    .slide-leave {
        transform: translateY(calc(32px - 100%));
    }

    #project-info {
        font-family: "Lucida Sans Unicode", "Lucida Grande", sans-serif;
        font-size: $font-sm;
        top: 0;
        right: 20px;
        width: 350px;
        position: fixed;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-end;

        @media screen and (max-width: $break-point) {
            right: 0;
            width: 100%;
            font-size: $font-md;
        }

        #info {
            -webkit-text-size-adjust: 100%;
            color: $black;
            border: 1px solid $border-color;
            border-top: none;
            border-bottom-left-radius: 5px;
            background-color: $white;
            padding: 0.25rem 1rem 1rem;

            @media screen and (max-width: $break-point) {
                border: none;
                border-radius: 0;
                border-bottom: 1px solid $border-color;
            }

            p {
                margin: 0.75rem 0;
            }

            a {
                color: $punch;
            }

            form {
                .inputs {
                    width: 100%;
                    display: flex;
                    flex-direction: row;
                    flex-wrap: nowrap;

                    input {
                        height: 30px;
                        font-size: $font-sm;
                        box-sizing: border-box;
                        border: 1px solid $black;
                        border-radius: 0;
                        -webkit-appearance: none;
                        margin: 0;

                        @media screen and (max-width: $break-point) {
                            height: 40px;
                        }
                    }

                    input[type='email'] {
                        flex-grow: 1;
                        padding: 0.5rem;
                        border-right: 0;
                        // This must be fixed at 16px for iPhone
                        font-size: $font-md;

                        &:active, &:focus {
                            outline: none;
                        }
                    }

                    input[type='submit'] {
                        flex-basis: 100px;
                        padding: 0;
                        background-color: $grey;

                        &:active, &:focus {
                            outline: none;
                        }

                        @media screen and (max-width: $break-point) {
                            flex-basis: 120px;
                            font-size: $font-md;
                        }
                    }
                }
            }
        }

        #tab {
            color: $white;
            font-weight: bold;
            background-color: $punch;
            padding: 0.5rem 2rem 0.75rem 0.75rem;
            height: 11px;
            position: relative;
            cursor: pointer;
            user-select: none;
            border: 1px solid $border-color;
            border-top: none;
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;

            @media screen and (max-width: $break-point) {
                font-size: $font-sm;
            }

            svg {
                position: absolute;
                right: 12px;
                top: 12px;
                fill: $white;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// ProjectInfo.vue?9f3a130c